import * as Yup from "yup"

export const storageLocationModel = Yup.object().shape({
  storage_location: Yup.string()
    .min(2, "minimum 2 characters required")
    .required("Please enter the storage location name"),
  total_capacity: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Please enter the total capacity"),
  capacity_unit: Yup.object().required("Please select the capacity unit"),
  current_address: Yup.object().shape({
    village: Yup.string()
      .min(2, "minimum 2 characters required")
      .required("Please enter the village name"),
    taluka: Yup.string().required("Please select a taluka"),
    local_area: Yup.string().required("Please enter local area"),
    district: Yup.string().required("Please select a district"),
    state: Yup.string().required("Please enter a valid state"),
    pincode: Yup.string()
      .matches(/^[0-9]{6}$/, "Please enter valid pincode")
      .transform(v => (v === "" ? null : v))
      .required("Please provide the pincode"),
    location: Yup.mixed().required(
      "Please select address location by moving the marker pin"
    ),
  }),
  agreement: Yup.object().shape({
    name: Yup.string().required("Please enter the agreement name"),
    start_date: Yup.date().required("Please select the start date"),
    end_date: Yup.date().required("Please select the end date"),
  }),
  transaction: Yup.object().shape({
    mode_of_payment: Yup.object().required("Please select the mode of payment"),
    amount: Yup.number()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .required("Please enter the amount"),
    transaction_id: Yup.string().required("Please enter the transaction ID"),
  }),
})
